import { render } from "./AboutNums.vue?vue&type=template&id=befb912a&scoped=true"
import script from "./AboutNums.vue?vue&type=script&lang=js"
export * from "./AboutNums.vue?vue&type=script&lang=js"

import "./AboutNums.vue?vue&type=style&index=0&id=befb912a&lang=scss&scoped=true"

import exportComponent from "/home/ajdin/forspace-web/forspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-befb912a"]])

export default __exports__